import jwt_decode from 'jwt-decode';
import { NavigateFunction } from 'react-router-dom';
import User from '../models/User';
import { postLogOut } from '../store/slice/userSlice';


/**
 * @function isEmpty
 * @description check if some object is empty or not.
 * @return { boolean }
 */
function isEmpty(obj: Record<string, any>): boolean {
  return Object.keys(obj).length === 0;
}

/**
 * @function typesValue
 * @description return the type value by typeId
 * @return { Type }
 */
function typesValue(type: number, row: User): string {
  if (row.isVencido) {
    return 'Invitación expirada';
  } else {
    switch (type) {
      case 0: {
        return 'Invitación enviada';
      }
      case 1: {
        return 'Habilitado';
      }
      case 2: {
        return 'Deshabilitado';
      }
      default: {
        return 'No especificado';
      }
    }
  }
}

/**
 * @function stateValue
 * @description return the stateValue by user state
 * @return { Type }
 */
function stateValue(type: any): any {
  let userAccess = [];
  if (type.accesoAdministracion === true) {
    userAccess.push(' Administración');
  }
  if (type.accesoGestion === true) {
    userAccess.push(' Gestion');
  }
  if (type.accesoCatastro === true) {
    userAccess.push(' Catastro');
  }
  if (type.accesoRegistros === true) {
    userAccess.push(' Registros');
  }
  return userAccess.toString();
}

/**
 * @function setColorValue
 * @description return the color by the user state
 * @return { Type }
 */
function setColorValue(type: number, isValid: boolean): string {
  if (isValid) {
    return 'org-user-table__tag';
  } else {
    switch (type) {
      case 0: {
        return 'org-user-table__tag__invitation__sent';
      }
      case 1: {
        return 'org-user-table__tag__enable';
      }
      case 2: {
        return 'default';
      }
      default: {
        return 'default';
      }
    }
  }
}

/**
 * @function breadCrumbItems
 * @description return the bread crumb name
 * @return { string }
 */
function breadCrumbItems(path: String): String {
  switch (path) {
    case 'admin': {
      return 'Inicio';
    }
    case 'tipos-tareas': {
      return 'Tipos de Tareas';
    }
    case 'accesoAdministracion': {
      return 'Inicio';
    }
    default: {
      return path;
    }
  }
}

function getTypeOf(v: string) {
  let response = 0;
  if (v.length >= 8) response = 1; // mayor a 8 digitos
  if (/^(?=.*[a-z])(?=.*[A-Z])/.test(v)) response = 2; // devuelve minusculas y mayusculas
  if (/^(?=.*[!#$%\-_=+<>])/.test(v)) response = 3; // devuelve minusculas y mayusculas
  return response;
}

/**
 * @function passwordRegex
 * @description return the bread crumb name
 * @return { string }
 */
function passwordRegex(password: string): number {
  return getTypeOf(password);
}

/**
 * @function passwordRegexCharacters
 * @description return the bread crumb name
 * @return { boolean }
 */
function passwordRegexCharacters(password: string): boolean {
  if (password.length >= 8 && /^(?=.*[a-z])(?=.*[0-9])/.test(password))
    return true;
  return false;
}

/**
 * @function passwordRegexLowUpp
 * @description return the bread crumb name
 * @return { string }
 */
function passwordRegexLowUpp(password: string): boolean {
  if (/^(?=.*[a-z])(?=.*[A-Z])/.test(password)) return true;
  return false;
}

/**
 * @function passwordRegexEspecial
 * @description return the bread crumb name
 * @return { string }
 */
function passwordRegexEspecial(password: string): boolean {
  if (/^(?=.*[!&*)(.#$%@\-_=+<>\W|_/g])/.test(password)) return true;
  return false;
}

/**
 * @function setAccessArray
 * @description return the array of access if the user access is true
 * @return { accessArray }
 */
function setAccessArray(access: any, isUserMenu: boolean): Array<any> {
  let accessArray = [];
  if (access.accesoAdministracion === true) {
    accessArray.push('accesoAdministracion');
  }
  if (access.accesoGestion === true) {
    accessArray.push('accesoGestion');
  }
  if (access.accesoCatastro === true) {
    accessArray.push('accesoCatastro');
  }
  if (access.accesoRegistros === true) {
    accessArray.push('accesoRegistros');
  }
  if (isUserMenu) {
    accessArray.push('Cerrar Sesion');
  }
  return accessArray;
}

/**
 * @function getDecodedAccessToken
 * @description return decode access token
 * @return { email }
 */
function getDecodedAccessToken(token: string): any {
  try {
    return jwt_decode(token);
  } catch (Error) {
    return null;
  }
}

/**
 * @function userSubMenu
 * @description set the real access name to show in the ui
 * @return { string }
 */
function userSubMenu(
  item: string,
  navigation: NavigateFunction,
  dispatch: any,
): any {
  switch (item) {
    case 'accesoAdministracion': {
      navigation('/admin');
      break;
    }
    case 'accesoCatastro': {
      navigation('/gestor-de-capas');
      break;
    }
    case 'accesoGestion': {
      navigation('/tareas');
      break;
    }
    case 'accesoRegistros': {
      navigation('/gestor-de-registros');
      break;
    }
    case 'logOut': {
      dispatch(postLogOut()).then(() => {
        window.localStorage.removeItem('accessToken');
        window.localStorage.removeItem('refreshToken');
        window.localStorage.removeItem('userName');
        window.localStorage.removeItem('currentUser');
        navigation('/login');
      });
      break;
    }
    default: {
      navigation('/' + item);
      break;
    }
  }
}

/**
 * @function taskStateItems
 * @description return the name and the color by state id (Tasks)
 * @return { object }
 */
function taskStateItems(state: number) {
  switch (state) {
    case 1: {
      return { title: 'Creada', className: 'create_color' };
    }
    case 2: {
      return { title: 'Asignada', className: 'assign_color' };
    }
    case 3: {
      return { title: 'Cerrada', className: 'close_color' };
    }
    case 4: {
      return { title: 'Pendiente', className: 'pending_color' };
    }
    case 5: {
      return { title: 'Rechazada', className: 'reject_color' };
    }
    default: {
      return { title: 'Sin estado', className: 'default' };
    }
  }
}

/**
 * @function taskStateUsers
 * @description return the name and the color by state id (Tasks users)
 * @return { object }
 */
function taskStateUsers(state: number) {
  switch (state) {
    case 1: {
      return { title: 'Asignada', className: 'assign_color' };
    }
    case 2: {
      return { title: 'Pendiente', className: 'pending_color' };
    }
    case 3: {
      return { title: 'Rechazada', className: 'reject_color' };
    }
    case 4: {
      return {
        title: 'Finalizada completa',
        className: 'finished_complete_color',
      };
    }
    case 5: {
      return {
        title: 'Finalizada incompleta',
        className: 'finished_incomplete_color',
      };
    }
    default: {
      return { title: 'Sin estado', className: 'default' };
    }
  }
}

/**
 * @function truncateStringEllipsis
 * @description return a string truncate with ellipsis
 * @return { string }
 */
const truncateStringEllipsis = (
  string: string | undefined,
  maxLength: number,
) => {
  if (string) {
    if (string?.length > maxLength) {
      return string?.substring(0, maxLength) + '...';
    } else {
      return string;
    }
  } else {
    return '-';
  }
};
/**
 * @function createInitialNames
 * @description return a string with the initial names
 * @return { string }
 */
const createInitialNames = (name?: string, lastName?: string) => {
  if (name && lastName) {
    return `${name[0]}${lastName[0]}`;
  }
  return '';
};
/**
 * rolPermission
 * @description return a string with the names of permissions
 * @return { string }
 */
const rolPermission = {
  COORDINACION: 0,
  EJECUCION: 1,
  AUTOGESTION: 2,
  SUPERVISION: 3,
};

const stateTask = {
  CREADA: 1,
  ASIGNADA: 2,
  CERRADA: 3,
  PENDIENTE: 4,
  RECHAZADA: 5,
};

const stateTaskUsers = {
  FINALIZADA_INCOMPLETA: 5,
  ASIGNADA: 1,
  FINLIZADA_COMPLETA: 4,
  PENDIENTE: 2,
  RECHAZADA: 3,
};

export function debounce(
  func: (...args: any[]) => any,
  wait: number,
  immediate: boolean,
) {
  let timeout: any;
  return function executedFunction(...args: any[]) {
    const later = function () {
      timeout = null;
      console.warn(args);
      if (!immediate) func(args);
    };
    const callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func(args);
  };
}

//Permissions pages

const permissionProfileAdmin = (navigation: NavigateFunction) =>{
  //@ts-ignore
  const currentUser: User = JSON.parse(localStorage.getItem('currentUser'));
  if(!currentUser.accesoAdministracion){
    navigation('dashboard')
  }
}

const permissionProfileGestion = (navigation: NavigateFunction) =>{
  //@ts-ignore
  const currentUser: User = JSON.parse(localStorage.getItem('currentUser'));
  if(!currentUser.accesoGestion){
    navigation('dashboard')
  }
}

export {
  isEmpty,
  typesValue,
  stateValue,
  setColorValue,
  breadCrumbItems,
  getTypeOf,
  passwordRegex,
  passwordRegexCharacters,
  passwordRegexLowUpp,
  passwordRegexEspecial,
  setAccessArray,
  getDecodedAccessToken,
  userSubMenu,
  taskStateItems,
  truncateStringEllipsis,
  createInitialNames,
  taskStateUsers,
  rolPermission,
  stateTask,
  stateTaskUsers,
  permissionProfileAdmin,
  permissionProfileGestion
};
